import { instanceOf, shape } from 'prop-types'

/**
 * The date interval object.
 *
 * @typedef {Object} DateInterval
 * @property {Date} start - Start of the period
 * @property {Date} end - End of the period
 */

export const intervalDatePropType = shape({
    end: instanceOf(Date).isRequired,
    start: instanceOf(Date).isRequired
})
